'use strict';exports.__esModule = true;var _noop = require('lodash/noop');var _noop2 = _interopRequireDefault(_noop);
var _constants = require('../constants');
var _axiosConfig = require('../helpers/axiosConfig');var _axiosConfig2 = _interopRequireDefault(_axiosConfig);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// todo: extend this service with other event types (different action/affected item)
// todo: change api url if needed

var createPropertyEvent = function createPropertyEvent(_ref) {var propertyId = _ref.propertyId,action = _ref.action;return (
    new Promise(function (resolve, reject) {return _axiosConfig2.default.post('/properties', {
        affected_id: propertyId,
        action: action }).

      then(function () {return resolve(
        (0, _noop2.default)());}).

      catch(reject);}));};


var createCompanyEvent = function createCompanyEvent(companyId) {return (
    new Promise(function (resolve, reject) {return _axiosConfig2.default.post('/companies', {
        affected_id: companyId,
        action: _constants.analyticsEventAction.CONTACT }).

      then(function () {return resolve(
        (0, _noop2.default)());}).

      catch(reject);}));};exports.default =


{
  createPropertyEvent: createPropertyEvent,
  createCompanyEvent: createCompanyEvent };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/services/AnalyticsEventService.js
// module id = 3057
// module chunks = 0